// extracted by mini-css-extract-plugin
export var active = "_3i-7";
export var container = "_3i-0";
export var evenWidth = "_3i-4";
export var large = "_3i-5";
export var outlet = "_3i-8";
export var slide = "_3i-2";
export var small = "_3i-6";
export var tab = "_3i-3";
export var tabs = "_3i-1";